import { render, staticRenderFns } from "./OrganismIpamManagement.vue?vue&type=template&id=1e6cef31&scoped=true&"
import script from "./OrganismIpamManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismIpamManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIpamManagement.vue?vue&type=style&index=0&id=1e6cef31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6cef31",
  null
  
)

export default component.exports